import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionsContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const { hasPermission } = usePermissions();

  return (
    <nav className="bg-gray-900 p-4 text-white flex justify-between">
      <div className="flex space-x-4">
        <Link to="/dashboard" className="hover:underline">Dashboard</Link>
        {user && hasPermission(user.role, 'canViewAllModules') && (
          <Link to="/services" className="hover:underline">Services</Link>
        )}
        {user && hasPermission(user.role, 'canAccessAdminPanel') && (
          <Link to="/admin" className="hover:underline">Admin Panel</Link>
        )}
      </div>
      <div>
        {user ? (
          <>
            <span className="mr-4">Bonjour, {user.email}</span>
            <button onClick={logout} className="bg-red-600 px-3 py-1 rounded hover:bg-red-700">Déconnexion</button>
          </>
        ) : (
          <Link to="/login" className="hover:underline">Connexion</Link>
        )}
      </div>
    </nav>
  );
}